import * as yup from "yup";
const loginSchema = yup.object().shape({
  email: yup.string().email().required("Enter a valid email"),
  password: yup.string().required("Wrong Password"),
});

export { loginSchema };
